// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2d7Nq","inputDescription":"styles_inputDescription__3HzRt"};